/** Shared business + site constants. Single source for contact, brand, and URLs. */

export const SITE = {
  name: "Fox Trucking LLC",
  shortName: "Fox Trucking",
  tagline: "LLC · Since 2012",
  foundingYear: "2012",
  founderName: "Umut Kenar",
  baseUrl: "https://foxtruckingllc.net",
  phoneDisplay: "862-371-9071",
  phoneTel: "8623719071",
  phoneE164: "+1-862-371-9071",
  email: "foxtruckingllc@yahoo.com",
  location: "New Jersey, USA",
  locationShort: "New Jersey",
  // TODO: Replace with confirmed street address when available.
  address: "[ADDRESS]",
  facebookUrl: "https://www.facebook.com/foxtruckingllc/",
  facebookHandle: "facebook.com/foxtruckingllc",
  ogImage:
    "https://storage.googleapis.com/gpt-engineer-file-uploads/attachments/og-images/06f56523-e76e-400e-8bac-9aa6cdacf383",
} as const;

export const NAV = {
  services: [
    { to: "/refrigerated-freight", label: "Refrigerated Freight" },
    { to: "/dry-van-freight", label: "Dry Van & General Freight" },
  ],
  primary: [
    { to: "/coverage", label: "Coverage" },
    { to: "/drive-with-us", label: "Drive With Us" },
    { to: "/about", label: "About" },
    { to: "/contact", label: "Contact" },
  ],
} as const;

export function absoluteUrl(path: string): string {
  if (path.startsWith("http")) return path;
  const normalized = path.startsWith("/") ? path : `/${path}`;
  return `${SITE.baseUrl}${normalized === "/" ? "/" : normalized}`;
}
